import { DataSource } from 'hooks/useHttpClient';
import { BasicMappedStatus } from './Candidate';

export const a = 1;

type LegacyStates = BasicMappedStatus & {
    cities: BasicMappedStatus[];
};

export type LegacyCountry = BasicMappedStatus & {
    states: LegacyStates[];
};

export const LegacyCountryResolver = (dataSource: DataSource, apiResponse: any): LegacyCountry[] => {
    try {
        switch (dataSource) {
            case 'hyrerocket':
                return apiResponse.map((country: any) => ({
                    id: country.id,
                    name: country.name,
                    states: country.states.map((state: any) => ({
                        id: state.id,
                        name: state.name,
                        cities: state.cities.map((city: any) => ({
                            id: city.id,
                            name: city.name
                        }))
                    }))
                }));

            default:
                return [];
        }
    } catch (error) {
        return [];
    }
};
